import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ENDPOINTS, CONSTANTS_KEY } from '../constants';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  
  constructor(
    private http: HttpClient,
    private configService: ConfigService) {
  }

  getAuthToken(code: string) {
    return this.http.post(ENDPOINTS.AUTH.replace('{server}', this.configService.config.server_admin), {
      code: code
    })
  }

  getToken() {
    return sessionStorage.getItem(CONSTANTS_KEY.TOKEN)
  }

  setToken(token: string) {
    sessionStorage.setItem(CONSTANTS_KEY.TOKEN, token)
  }

  removeToken() {
    sessionStorage.removeItem(CONSTANTS_KEY.TOKEN)
  }
}
